import React from "react";
import Select from "react-select";
import { IconType } from "react-icons";

import { fieldIconClass, filterLabelClass } from "./styles";
import { iconSelectStyles } from "../../static/styles";

export type FilterOption<T> = { value: T; label: string };

type FilterSelectProps<T> = {
  label: string;
  icon: IconType;
  placeholder: string;
  options: FilterOption<T>[];
  value: T | null;
  onChange: (value: T | null) => void;
  isClearable?: boolean;
  isSearchable?: boolean;
};

// A select of a list page's filter card, with its field icon.
const FilterSelect = <T extends string | number>({
  label,
  icon: Icon,
  placeholder,
  options,
  value,
  onChange,
  isClearable = false,
  isSearchable = false,
}: FilterSelectProps<T>) => (
  <div className="space-y-2">
    <label className={filterLabelClass}>{label}</label>
    <div className="relative">
      <Icon className={fieldIconClass} />
      <Select
        styles={iconSelectStyles}
        className="react-select-container"
        classNamePrefix="react-select"
        placeholder={placeholder}
        options={options}
        isClearable={isClearable}
        isSearchable={isSearchable}
        value={options.find((option) => option.value === value) || null}
        onChange={(option: any) => onChange(option ? option.value : null)}
      />
    </div>
  </div>
);

export default FilterSelect;
